export default __webpack_public_path__ + "static/media/hills-top.d8eea2f3.svg";